import { Injectable } from '@angular/core';
import { EventService } from '@spartacus/core';
import { Ga4GgDownloadEvent } from '../../events/analytics/ga4/general/ga4-gg-download.event';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private eventService: EventService) {}

  public dispatchGa4GgDownloadEvent() {
    this.eventService.dispatch<Ga4GgDownloadEvent>(
      {
        event: 'file_download',
      },
      Ga4GgDownloadEvent
    );
  }
}
